<div class="title-container">
  <h2 class="title"> {{ 'Reports.Score.Title' | translate }} </h2>
  <hr class="separation-line" />
</div>
<section class="filters-container">
  <div class="fieldrow">
    <fieldset class="customers">
      <label class="label"> {{'Reports.Filters.CustomerNumbers' | translate}} </label>
      <custom-multi-select [options]="customers$ | async" [clearEnabled]="true" [searchEnabled]="true"
        [(selectedKeys)]="selectedCustomers" [displayDetailedSelection]="true" [disabled]="userAssignedCustomersCount <= 1"
        (selectedKeysChange)="onSelectedCustomersChange($event)">
      </custom-multi-select>
    </fieldset>
    <div class="fieldrow">
      <button class="button-basic" [disabled]="isLoading"
        (click)="onGenerateReport()">{{'Reports.Buttons.GenerateReport' | translate}}</button>
      <button class="button-basic-reverse" [disabled]="isLoading"
        (click)="onExportExcelClick()">{{'Reports.Buttons.Download' | translate}} </button>
    </div>
  </div>
</section>
<section class="results-container" *ngIf="scoresSummary">
  <p-table size="small"[columns]="columns" selectionMode="single"
    [loading]="isLoading" [value]="scoresSummary" dataKey="score" [scrollable]="true">
    <ng-template pTemplate="header">
      <tr>
        <th></th>
        <th></th>
        <th *ngFor="let col of columns"> {{ col.translationTag | translate }} </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-summary let-columns="columns" let-expanded="expanded">
      <tr>
        <td>
          <button type="button" pButton pRipple class="button-transparent" [pRowToggler]="summary"
            [icon]="expanded ? 'pi pi-minus' : 'pi pi-plus'" (click)="getDetails(summary.score)"></button>
        </td>
        <td class="score {{summary.score}} icon"></td>
        <td *ngFor="let col of columns">
          <ng-container [ngSwitch]="col.type">
            <ng-container *ngSwitchCase="'decimal'"> {{ summary[col.name] | number : numberFormat.style:
              numberFormat.culture }} </ng-container>
            <ng-container *ngSwitchDefault>{{summary[col.name]}}</ng-container>
          </ng-container>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="expandedrow" let-summary>
      <tr>
        <td class="p-3" colspan="11">
          <p-table [value]="summary.cases" dataKey="score" [paginator]="true" (onLazyLoad)="onPageChange($event)"
            [(rows)]="numberOfRowsPerPage" [rowsPerPageOptions]="[25,50,100]" [totalRecords]="totalNumberOfItems"
            selectionMode="single" [loading]="isLoading">
            <ng-template pTemplate="header">
      <tr>
        <th *ngFor="let col of subColumns"> {{ col.translationTag | translate }} </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-case let-columns="subColumns">
      <tr class="clickable">
        <td *ngFor="let sub of subColumns" (click)="onOpenCase(case)">
          <ng-container [ngSwitch]="sub.type">
            <ng-container *ngSwitchCase="'decimal'"> {{ case[sub.name] | number : numberFormat.style:
              numberFormat.culture }} </ng-container>
            <ng-container *ngSwitchDefault>{{case[sub.name]}}</ng-container>
          </ng-container>
        </td>
      </tr>
    </ng-template>
  </p-table>
  </td>
  </tr>
  </ng-template>
  </p-table>
</section>
<section class="explanation-container">
  <div class="score-container">
    <span class="score Green">{{'Debtor.CreditScore.Green' | translate}}</span>
    <span class="description">{{('Debtor.CreditScore.Description.Green' ) | translate}}</span>
  </div>
  <div class="score-container">
    <span class="score Yellow">{{'Debtor.CreditScore.Yellow' | translate}}</span>
    <span class="description">{{('Debtor.CreditScore.Description.Yellow' ) | translate}}</span>
  </div>
  <div class="score-container">
    <span class="score Red">{{'Debtor.CreditScore.Red' | translate}}</span>
    <span class="description">{{('Debtor.CreditScore.Description.Red' ) | translate}}</span>
  </div>
</section>
